<template>
  <nav class="navbar-expand-lg primary-navbar navbar " role="navigation">
      <a v-if="hasCustomLogo" class="navbar-brand custom-logo" href="/" :aria-label="`Go to ${organization.name} Home`"
         :style="`background: url(${customLogoSrc}) no-repeat center center / 36px;`">
        <span class="sr-only">{{organization.name}}</span>
      </a>
      <a v-else class="navbar-brand formability-logo" href="/" aria-label="Go to Formability Home">
        <span class="sr-only">Formability</span>
      </a>

      <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
      <div v-if="isNotOneStop" class="save-status"></div>

      <slot name="body"></slot>

      <div class="navbar-nav">
        <unread-notifications></unread-notifications>

        <div class="dropdown menu-dropdown">
          <button class="dropdown-toggle arrow" id="loginDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <avatar :user=user :current-user-id="user.id"></avatar>
            <span class="avatar-dropdown-title">{{user | firstName}}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right uncover" aria-labelledby="loginDropdown">
            <li class="red" v-if="organization">
              <h6>{{organization.name}}</h6>
            </li>
            <li>
              <a class="dropdown-item" href="/">My Dashboard</a>
            </li>
            <li v-if="$can('viewOrganizationManagement', user)">
              <a class="dropdown-item" href="/organization">Manage Members</a>
            </li>
            <li v-if="$can('viewDocumentManagement', user)">
              <a class="dropdown-item" href="/documents">Manage Apps</a>
            </li>
            <li v-if="$can('viewPortalManagement', user)">
              <a class="dropdown-item" href="/portals">Manage Portals</a>
            </li>
            <li v-if="$can('viewOrganizationSettings', user)">
              <a class="dropdown-item" href="/organization/settings">Organization Settings</a>
            </li>
            <li>
              <a class="dropdown-item" href="/account">Personal Settings</a>
            </li>
            <li v-if="$can('viewReportingDashboard', user)">
              <a class="dropdown-item" href="/analyst_dashboard">Reporting & Submissions</a>
            </li>
            <li v-if="$can('viewDashboardAnalyticsManager', user)">
              <a class="dropdown-item" href="/analytics">Analytics</a>
            </li>
            <li class="dropdown-divider"></li>
<!--            Hiding it for clever crocodile release. -->
<!--            <li>-->
<!--              <a class="dropdown-item" href="/documentation">Help</a>-->
<!--            </li>-->
            <li class="dropdown-item cta">
              <button type="button" class="btn grey-to-blue xs" @click="showSwitchOrganizations">Switch Organization</button>
              <a rel="nofollow" data-method="delete" href="/users/sign_out">Log out</a>
            </li>
          </ul>
      </div>
      <switch-organization
        slot="modal"
        v-if="modalStateFor(vueModalID.switchOrganization, ModalStatus.Confirmation).isVisible"
        :state="modalStateFor(vueModalID.switchOrganization)"
        :index="vueModalID.switchOrganization"
        @toggle-modal="hideModal(vueModalID.switchOrganization)"
        :selected-organization="organization"
        @create-new-organization="createNewOrganization"
        @join-organization="joinOrganization"
        :user="user">
      </switch-organization>
      <create-organization
        slot="modal"
        v-if="modalStateFor(vueModalID.createOrganization, ModalStatus.Confirmation).isVisible"
        :state="modalStateFor(vueModalID.createOrganization)"
        :index="vueModalID.createOrganization"
        @return="showSwitchOrganizations">
      </create-organization>
      <join-organization
        slot="modal"
        v-if="modalStateFor(vueModalID.joinOrganization, ModalStatus.Confirmation).isVisible"
        :state="modalStateFor(vueModalID.joinOrganization)"
        :index="vueModalID.joinOrganization"
        @return="showSwitchOrganizations">
      </join-organization>
    </div>
  </nav>

</template>

<script lang="ts">
  import Vue from "vue";
  import Initialable from '../../mixins/initialable'
  import UnreadNotifications from './unreadNotifications.vue';
  import SwitchOrganization from '../modals/organizations/switchOrganization.vue'
  import CreateOrganization from '../modals/organizations/createOrganization.vue'
  import JoinOrganization from '../modals/organizations/joinOrganization.vue'
  import Selected from "../../state/modules/selected";
  import RouterMixin from "../../mixins/routerMixin";
  import Avatar from "../avatar.vue"
  import IBreadcrumb from "../../interfaces/breadcrumbInterfaces";
  import Breadcrumbs from "../breadcrumbs.vue";

  export default Vue.extend({
    components: {
      UnreadNotifications,
      SwitchOrganization,
      CreateOrganization,
      JoinOrganization,
      Avatar,
      Breadcrumbs,
    },
    mixins: [Initialable, RouterMixin],
    props: {
      user: {
        default: null,
      },
      showCustomLogo: {
        type: Boolean,
        required: true
      },
      breadcrumbs: {
        type: Array as () => IBreadcrumb[],
        default: () => {
          return [];
        }
      }
    },
    data: function () {
      return {};
    },
    computed: {
      organization() {
        return Selected.organization.get();
      },
      hasCustomLogo(): boolean {
        if (this.showCustomLogo) {
          return !!this.organization.logo;
        } else {
          return false;
        }
      },
      customLogoSrc(): string {
        return `/organization/settings/image_uploads/${this.organization.logo.id}`;
      },
      allModalIds(): number[] {
        return [
          this.vueModalID.createOrganization,
          this.vueModalID.switchOrganization,
          this.vueModalID.joinOrganization,
        ];
      }
    },
    methods: {
      showSwitchOrganizations(): void {
        this.switchModal(this.vueModalID.switchOrganization);
      },
      createNewOrganization(event): void {
        this.switchModal(this.vueModalID.createOrganization);
      },
      joinOrganization(event): void {
        this.switchModal(this.vueModalID.joinOrganization);
      },
      switchModal(modalId: number): void {
        this.allModalIds.forEach(id => modalId === id ? this.showModal(id) : this.hideModal(id));
      },
    },
  });
</script>